<div
  id="system-notifications-container"
  [class.expanded]="isSideNavExpanded()"
  [class.offset-for-sidenav]="isSideNavVisible()">
  @for (notification of state.notifications(); track notification.uId) {
    <div
      animate.enter="enter-animation"
      animate.leave="leave-animation">
      <topo-system-notification-banner
        [notification]="notification"
        (onClose)="state.removeMessage($event)" />
    </div>
  }
</div>
